
import Vue from 'vue'
import moment from 'moment'
import authService from '@/services/support/AuthService'
import cookiesService from '@/services/support/CookiesService'
import config from '@/config'
import { MessageError } from './components/generic/MessageHandling.vue'
import { removeJWTAccessToken, removeJWTRefreshToken } from './api'
import LogService from './services/support/LogService'

export default Vue.extend({
  data () {
    return {
      ready: false
    }
  },

  async created () {
    cookiesService.config('1d', '/', config.appDomain)
    if (cookiesService.get(config.jwtAccessTokenCookieName)) {
      try {
        await authService.initAuth()
      } catch (error) {
        removeJWTAccessToken()
        new MessageError({
          propsData: {
            title: 'Error de token de acceso.',
            message: '',
            delay: 10000,
            error: error } }).displayMessage()
        LogService.error('Error on init user on created app. ' + error)
      }
    } else if (cookiesService.get(config.refreshTokenCookieName)) {
      try {
        await authService.refreshToken(cookiesService.get(config.refreshTokenCookieName))
      } catch (error) {
        removeJWTRefreshToken()
        new MessageError({
          propsData: {
            title: 'Error de token de refresco.',
            message: '',
            delay: 10000,
            error: error } }).displayMessage()
        LogService.error('Error on init user by refresh token on created app. ' + error)
      }
    }
    this.ready = true
  },

  mounted () {
    moment.locale('es')
  }
})
